import $ from 'jquery';
import isTouch from '../exports/touch-detect';

var modelJsonSections = {};
var models = {};
var xrButtons = {};

export default function initSectionModels(modelViewerContainers, sectionId) {
  modelJsonSections[sectionId] = {
    loaded: false,
  };

  modelViewerContainers.each(function(index) {
    var $modelViewerContainer = $(this);
    var mediaId = $modelViewerContainer.data('media-id');
    var $modelViewerElement = $($modelViewerContainer.find('model-viewer')[0]);

    var modelId = $modelViewerElement.data('model-id');

    if (index === 0) {
      var $xrButton = $modelViewerContainer
        .closest('[data-product-wrapper]')
        .find('[data-shopify-xr]');

      xrButtons[sectionId] = {
        $element: $xrButton,
        defaultId: modelId,
      };
    }

    models[mediaId] = {
      modelId: modelId,
      mediaId: mediaId,
      sectionId: sectionId,
      $container: $modelViewerContainer,
      $element: $modelViewerElement,
    };
  });

  window.Shopify.loadFeatures([
    {
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr,
    },
    {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi,
    },
  ]);
}

function setupShopifyXr(errors) {
  if (errors) {
    console.warn(errors);
    return;
  }
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function() {
      setupShopifyXr();
    });
    return;
  }

  for (var sectionId in modelJsonSections) {
    if (modelJsonSections.hasOwnProperty(sectionId)) {
      var modelSection = modelJsonSections[sectionId];
      if (modelSection.loaded) { continue; }

      var $modelJson = $('#ModelJson-' + sectionId);
      if ($modelJson.length) {
        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
  }
  window.ShopifyXR.setupXRElements();
}

function setupModelViewerUi(errors) {
  if (errors) {
    console.warn(errors);
    return;
  }

  for (var key in models) {
    if (models.hasOwnProperty(key)) {
      var model = models[key];
      if (!model.modelViewerUi) {
        model.modelViewerUi = new Shopify.ModelViewerUI(model.$element[0]);
      }
      setupModelViewerListeners(model);
    }
  }
}

function setupModelViewerListeners(model) {
  model.$container
    .on('pause', function() {
      if (model.modelViewerUi.pause) { model.modelViewerUi.pause(); }
    })
    .on('play-desktop', function() {
      if (model.modelViewerUi.play && !isTouch()) { model.modelViewerUi.play(); }
    })
    .on('play', function() {
      if (model.modelViewerUi.play) { model.modelViewerUi.play(); }
    });
}
